import { Injectable } from '@angular/core';
import { ApiNameList } from '../../../../../environments/api-name-list';
import { HttpClientService } from '../../../../common/services/http-client-service';

@Injectable()
export class DetailsService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    getStudentInfo(participationId?: number, enrollmentId?: number, storyId?: string): any {
        enrollmentId = enrollmentId ? enrollmentId : null;
        const requestObject = {
            participationId,
            enrollmentId,
            storyId
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.myDetails, requestObject);
    }

    updateStudentInfo(requestObject: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.updateMyDetails, requestObject);
    }

    updateAllStudentInfo(requestObject: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.updateAllDetails, requestObject);
    }

    getParticipationIdStudentId(requestObject: any) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getParticipationIdStudentId, requestObject);
    }
}
